
export default {
  props: {
    name: {
      type: String,
      default: () => '',
    },
    documentos: {
      type: String,
      default: () => '',
    },
  },
}
